import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Product } from 'src/app/models/interface/product/product';
import { FtthService } from 'src/app/services/api/ftth/ftth.service';
import { NetworkService } from 'src/app/services/api/network/network.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ERROR_OPERATIONAL_STATES_RETRY_MAPPING } from 'src/app/utils/Constants';
import { ProductDepthLevelProductActionsComponent } from '../product-depth-level-product-actions.component';

@Component({
  selector: 'app-retry',
  templateUrl: './retry.component.html',
  styleUrls: ['./retry.component.scss']
})
export class RetryComponent implements OnInit {

  item: Product;
  loading: boolean;

  private subscriptions = new Subscription();

  constructor(
    private networkService: NetworkService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private dialogRef: MatDialogRef<ProductDepthLevelProductActionsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      item: Product;
      type: string;
    },
  ) {

  }

  ngOnInit() {
    this.loading = false;
    this.item = this.data.item;

    if (this.data.type !== 'product') {
      throw new Error('It must be a product');
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  retry() {
    this.loading = true;
    this.networkService.retry(this.item.cfses[0].serviceId, ERROR_OPERATIONAL_STATES_RETRY_MAPPING[this.item.cfses[0].operationalState])
      .subscribe(
        (data) => {
          this.loading = false;
          this.dialogRef.close(true);
          this.notificationsService.showNotification(this.translateService.instant('RETRY_PRODUCT.success'), NotificationLevel.SUCCESS);
        },
        (error) => {
          this.loading = false;
          this.notificationsService.showNotification(this.translateService.instant('RETRY_PRODUCT.error'), NotificationLevel.ERROR);
        }
      );

  }

}
